import { api } from '@/api/core/api';

interface TriggerOomReviewRequest {
  caseReferences: string[];
}

const triggerOomReviewApi = api.injectEndpoints({
  endpoints: (builder) => ({
    triggerOomReview: builder.mutation<void, TriggerOomReviewRequest>({
      query: (body) => ({
        url: `oom-review/trigger-ingest`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useTriggerOomReviewMutation } = triggerOomReviewApi;
